// taken from http://stackoverflow.com/a/35548094 (not very good)
Object.defineProperty(Array.prototype, 'flatten', { // eslint-disable-line no-extend-native
  enumerable: false,
  configurable: false,
  writable: false,
  value: function () {
    const flat = [].concat(...this)
    return flat.some(Array.isArray) ? this.flatten(flat) : flat
  }
})

// Format join with words.
// [1, 2, ..., 3] = '1, 2, ..., and 3'
// [1, 2] = '1 and 2'
// [1] = '1'
// [] = ''
Object.defineProperty(Array.prototype, 'joinAnd', { // eslint-disable-line no-extend-native
  enumerable: false,
  configurable: false,
  writable: false,
  value: function (seperator = ',', word = 'and', oxford = true) {
    if (!this || !this.length) return ''

    let arr = this.slice()
    const lastItem = arr.splice(-1)
    arr = arr.length ? [arr.join(`${seperator} `)] : []
    arr.push(lastItem)

    oxford = oxford && arr.length > 2 || false // oxford only for 3+ elements
    return arr.join(`${oxford && seperator || ''} ${word} `)
  }
})

/**
 * Taken From and Updated to ES6 http://stackoverflow.com/a/14428340
 *
 * Number.prototype.format(n, x, s, c)
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 * @param string  prepend: eg. $ (dollar symbol)
 * @param string  append: eg. ¢ (cent symbol)
 */
Object.defineProperty(Number.prototype, 'formatPrice', { // eslint-disable-line no-extend-native
  enumerable: false,
  configurable: false,
  writable: false,
  value: function (n = 2, x = 3, s = ',', c = '.', prepend = '$', append = '') {
    let re = '\\d(?=(\\d{' + x + '})+' + (n > 0 ? '\\D' : '$') + ')'
    let num = this.toFixed(Math.max(0, ~~n))

    let output = prepend + (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + s) + append

    if (s !== c) { // if seperators aren't the same as decimal delimiters, replace trailing zeros, ie. $7.00 to $7
      output = output.replace(`${c}${'0'.repeat(n)}`, '')
    }

    return output
  }
})

// taken from http://stackoverflow.com/a/2970667
Object.defineProperty(String.prototype, 'camelize', { // eslint-disable-line no-extend-native
  enumerable: false,
  configurable: false,
  writable: false,
  value: function () {
    if (!this) return ''
    return this.replace('_', ' ').replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
      if (+match === 0) return ''
      return index === 0 ? match.toLowerCase() : match.toUpperCase()
    })
  }
})

Object.defineProperty(String.prototype, 'capitalize', { // eslint-disable-line no-extend-native
  enumerable: false,
  configurable: false,
  writable: false,
  value: function () {
    if (!this) return ''
    return this.charAt(0).toUpperCase() + this.slice(1)
  }
})

// String format with placeholders, like sprintf; taken from http://stackoverflow.com/a/5077091
Object.defineProperty(String.prototype, 'replaceFormat', { // eslint-disable-line no-extend-native
  enumerable: false,
  configurable: false,
  writable: false,
  value: function () {
    const args = arguments
    return this.replace(/\{\{|\}\}|\{(\d+)\}/g, (m, n) => {
      if (m === '{{') return '{'
      if (m === '}}') return '}'
      return args[n]
    })
  }
})

// taken from http://stackoverflow.com/a/37511463
Object.defineProperty(String.prototype, 'stripDiatrics', { // eslint-disable-line no-extend-native
  enumerable: false,
  configurable: false,
  writable: false,
  value: function () {
    if (!this) return ''
    if (typeof this.normalize !== 'function') return this
    if (typeof this.normalize('NFD').replace !== 'function') return this
    return this.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }
})



// WEBPACK FOOTER //
// ./both/helpers/polyfills.js